export default "data:image/jpeg;base64,ZXhwb3J0IGRlZmF1bHQgIl9fVklURV9BU1NFVF9fZTlmODY2NmVfXyI="